import React from 'react';

import Row from 'components/track-events/row/Row';

export default function Content(props) {
  return (
    <div className='track-events-content'>{
      props.rows.map((item, index) => {
        return (<Row
          key={ index }
          item={ item }
          trackId={ props.trackId }
          isShort={ props.isShort || false }
        />);
      })
    }</div>
  );
}
